"use client";

import { c as _c } from "react/compiler-runtime";
import type { WaveGroupsConfig } from "@/types/waves.types";
import { CreateWaveGroupConfigType } from "@/types/waves.types";
import { CREATE_WAVE_NONE_GROUP_LABELS, CREATE_WAVE_SELECT_GROUP_LABELS } from "@/helpers/waves/waves.constants";
import type { ApiCreateGroup } from "@/generated/models/ApiCreateGroup";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import CreateWaveToggle from "../utils/CreateWaveToggle";
import { buildInlineGroupName } from "./createWaveInlineGroupBuilder";
import CreateWaveGroupInlinePanel from "./CreateWaveGroupInlinePanel";
export default function CreateWaveGroup(t0) {
  const $ = _c(28);
  const {
    waveName,
    waveType,
    groupType,
    chatEnabled,
    adminCanDeleteDrops,
    setChatEnabled,
    onGroupSelect,
    onInlineGroupCreate,
    groupsCache,
    groups,
    setDropsAdminCanDelete
  } = t0;
  const getSelectedGroupId = () => {
    switch (groupType) {
      case CreateWaveGroupConfigType.ADMIN:
        {
          return groups.admin;
        }
      case CreateWaveGroupConfigType.CAN_VIEW:
        {
          return groups.canView;
        }
      case CreateWaveGroupConfigType.CAN_DROP:
        {
          return groups.canDrop;
        }
      case CreateWaveGroupConfigType.CAN_VOTE:
        {
          return groups.canVote;
        }
      case CreateWaveGroupConfigType.CAN_CHAT:
        {
          return groups.canChat;
        }
      default:
        {
          return null;
        }
    }
  };
  const selectedGroupId = getSelectedGroupId();
  const selectedGroup = selectedGroupId && groupsCache[selectedGroupId] ? groupsCache[selectedGroupId] : null;
  const isNotChatWave = waveType !== ApiWaveType.Chat;
  const inputDisabled = isNotChatWave && groupType === CreateWaveGroupConfigType.CAN_CHAT && !chatEnabled;
  const defaultLabel = CREATE_WAVE_NONE_GROUP_LABELS[groupType];
  const groupLabel = CREATE_WAVE_SELECT_GROUP_LABELS[waveType][groupType];
  let t1;
  if ($[0] !== groupLabel || $[1] !== waveName) {
    t1 = buildInlineGroupName({
      waveName,
      groupLabel
    });
    $[0] = groupLabel;
    $[1] = waveName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const suggestedName = t1;
  let t2;
  if ($[3] !== groupLabel) {
    t2 = <h3 className="tw-mb-0 tw-text-lg tw-font-semibold tw-tracking-tight tw-text-iron-50 sm:tw-text-xl">{groupLabel}</h3>;
    $[3] = groupLabel;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== chatEnabled || $[6] !== groupType || $[7] !== isNotChatWave || $[8] !== setChatEnabled) {
    t3 = isNotChatWave && groupType === CreateWaveGroupConfigType.CAN_CHAT && <CreateWaveToggle enabled={chatEnabled} onChange={setChatEnabled} label="Enable chat" displayLabel={true} />;
    $[5] = chatEnabled;
    $[6] = groupType;
    $[7] = isNotChatWave;
    $[8] = setChatEnabled;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== adminCanDeleteDrops || $[11] !== groupType || $[12] !== setDropsAdminCanDelete) {
    t4 = groupType === CreateWaveGroupConfigType.ADMIN && <CreateWaveToggle enabled={adminCanDeleteDrops} onChange={setDropsAdminCanDelete} label="Allow admins to delete posts" displayLabel={true} />;
    $[10] = adminCanDeleteDrops;
    $[11] = groupType;
    $[12] = setDropsAdminCanDelete;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">{t2}{t3}{t4}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== defaultLabel || $[19] !== inputDisabled || $[20] !== onGroupSelect || $[21] !== onInlineGroupCreate || $[22] !== selectedGroup || $[23] !== suggestedName) {
    t6 = <CreateWaveGroupInlinePanel suggestedName={suggestedName} defaultLabel={defaultLabel} disabled={inputDisabled} selectedGroup={selectedGroup} onChange={onGroupSelect} onCreateGroup={onInlineGroupCreate} />;
    $[18] = defaultLabel;
    $[19] = inputDisabled;
    $[20] = onGroupSelect;
    $[21] = onInlineGroupCreate;
    $[22] = selectedGroup;
    $[23] = suggestedName;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t5 || $[26] !== t6) {
    t7 = <div className="tw-flex tw-flex-col tw-gap-y-4">{t5}{t6}</div>;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
}